module.exports = __webpack_public_path__ + "img/164.048d500d.jpg";